export default (url) =>
  process.env.NODE_ENV === 'production' && url ? url.replace(/^http:\/\//i, 'https://') : url;
